"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const facebook_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/facebook.svg"));
const instagram_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/instagram.svg"));
const linkedin_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/linkedin.svg"));
const rss_feed_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/rss_feed.svg"));
const twitter_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/twitter.svg"));
const youtube_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/youtube.svg"));
const __1 = require("../../..");
const socialIcons = [
    { id: 'facebook', src: facebook_svg_1.default, alt: 'Facebook' },
    { id: 'instagram', src: instagram_svg_1.default, alt: 'Instagram' },
    { id: 'linkedin', src: linkedin_svg_1.default, alt: 'LinkedIn' },
    { id: 'rss', src: rss_feed_svg_1.default, alt: 'RSS' },
    { id: 'twitter', src: twitter_svg_1.default, alt: 'Twitter' },
    { id: 'youtube', src: youtube_svg_1.default, alt: 'YouTube' }
];
function FooterSocialLink({ type, url }) {
    const selectedIcon = socialIcons.find((icon) => icon.id === type);
    return ((0, jsx_runtime_1.jsx)(__1.Grid.Col, { width: "auto", children: (0, jsx_runtime_1.jsx)("a", { className: "usa-social-link", href: url, children: (0, jsx_runtime_1.jsx)("img", { src: selectedIcon?.src, alt: selectedIcon?.alt, className: "usa-social-link__icon" }) }) }));
}
exports.default = FooterSocialLink;
